import React from 'react';
import { colors, spacing, typography } from '../../../design-system/index.js';

export const GlobalFooter = () => {
  const footerStyles = {
    backgroundColor: colors.background.secondary,
    borderTop: `1px solid ${colors.border.default}`,
    padding: `${spacing[12]} 0 ${spacing[8]}`,
    marginTop: 'auto',
  };

  const containerStyles = {
    maxWidth: spacing.layout.containerMaxWidth,
    margin: '0 auto',
    padding: `0 ${spacing[6]}`,
  };

  const footerContentStyles = {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr',
    gap: spacing[12],
    marginBottom: spacing[8],
  };

  const brandSectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[4],
  };

  const logoStyles = {
    fontSize: typography.fontSize.xl,
    fontWeight: typography.fontWeight.normal,
    color: colors.text.primary,
    margin: 0,
  };

  const brandDescStyles = {
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.loose,
    color: colors.text.secondary,
    maxWidth: '300px',
    margin: 0,
  };

  const footerSectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[3],
  };

  const sectionTitleStyles = {
    fontSize: typography.fontSize.base,
    fontWeight: typography.fontWeight.normal,
    color: colors.text.primary,
    marginBottom: spacing[2],
    margin: `0 0 ${spacing[2]} 0`,
  };

  const linkListStyles = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[2],
  };

  const linkStyles = {
    fontSize: typography.fontSize.sm,
    color: colors.text.secondary,
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    cursor: 'pointer',
  };

  const footerBottomStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: spacing[6],
    borderTop: `1px solid ${colors.border.light}`,
    flexWrap: 'wrap',
    gap: spacing[4],
  };

  const copyrightStyles = {
    fontSize: typography.fontSize.sm,
    color: colors.text.muted,
    margin: 0,
  };

  const metaLinksStyles = {
    display: 'flex',
    gap: spacing[6],
    listStyle: 'none',
    padding: 0,
    margin: 0,
  };

  const responsiveStyles = `
    @media (max-width: 768px) {
      .footer-content {
        grid-template-columns: 1fr !important;
        gap: ${spacing[8]} !important;
      }
      .footer-bottom {
        flex-direction: column !important;
        text-align: center;
        gap: ${spacing[4]} !important;
      }
    }
  `;

  const quickLinks = [
    { text: "首页", href: "#" },
    { text: "关于", href: "#" },
    { text: "项目", href: "#" },
    { text: "联系", href: "#" }
  ];

  const resourceLinks = [
    { text: "博客文章", href: "#" },
    { text: "技术分享", href: "#" },
    { text: "开源项目", href: "#" },
    { text: "简历下载", href: "#" }
  ];

  const metaLinks = [
    { text: "隐私政策", href: "#" },
    { text: "使用条款", href: "#" },
    { text: "站点地图", href: "#" }
  ];

  const handleLinkMouseEnter = (e) => {
    e.target.style.color = colors.text.primary;
  };

  const handleLinkMouseLeave = (e) => {
    e.target.style.color = colors.text.secondary;
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer style={footerStyles} className="global-footer">
      <div style={containerStyles}>
        <div style={footerContentStyles} className="footer-content">
          {/* 品牌信息 */}
          <div style={brandSectionStyles}>
            <h3 style={logoStyles}>张三</h3>
            <p style={brandDescStyles}>
              专注于创造优雅的用户体验和高质量的代码。
              如果您有项目需求或技术合作意向，欢迎联系我。
            </p>
          </div>

          {/* 快速链接 */}
          <div style={footerSectionStyles}>
            <h4 style={sectionTitleStyles}>快速导航</h4>
            <ul style={linkListStyles}>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    style={linkStyles}
                    onMouseEnter={handleLinkMouseEnter}
                    onMouseLeave={handleLinkMouseLeave}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 资源链接 */}
          <div style={footerSectionStyles}>
            <h4 style={sectionTitleStyles}>资源中心</h4>
            <ul style={linkListStyles}>
              {resourceLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    style={linkStyles}
                    onMouseEnter={handleLinkMouseEnter}
                    onMouseLeave={handleLinkMouseLeave}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 页脚底部 */}
        <div style={footerBottomStyles} className="footer-bottom">
          <div style={copyrightStyles} className="footer-meta">
            <p style={{margin: 0}}>
              © {currentYear} 张三. 保留所有权利.
            </p>
            <p style={{margin: `${spacing[1]} 0 0 0`, fontSize: typography.fontSize.xs}}>
              ICP备案号: 京ICP备12345678号
            </p>
          </div>
          
          <ul style={metaLinksStyles}>
            {metaLinks.map((link, index) => (
              <li key={index}>
                <a
                  href={link.href}
                  style={linkStyles}
                  onMouseEnter={handleLinkMouseEnter}
                  onMouseLeave={handleLinkMouseLeave}
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style>{responsiveStyles}</style>
    </footer>
  );
};
